export default __webpack_public_path__ + "static/media/thirth.43cbd342.jpg";